import React from "react";

const About = () => {
  return (
    <div className="aboutSection" id="about">
      <h2>ABOUT</h2>
      <p>
        Villa Adriart is located in the heart of rural Dalmatia, in the
        sun-bathed Dalmatian village of Stankovci, hidden from mass tourism, yet
        close enough to the historical coastal cities of Zadar, Šibenik, Split
        and numerous National and Nature parks.
      </p>
      <p>
        Distinctively equipped, with its 200 m2 indoor and 3000m2 outdoor space
        villa offers you four bedrooms and four bathrooms, spacious living room
        with panoramic view, sauna, indoor play room with darts and billiard,
        vegetable garden, traditional dalmatian taverna with barbecue amenities
        next to the heated swimming pool, 200m2 large football and tennis court.
        Villa Adriart is perfect for your family vacation in complete privacy.
      </p>
      <p>
        The villa is built in a way that carefully preserves the traditional
        architectural form and design. It provides you with a unique experience
        of Dalmatian way of life, as such it represents your perfect place for a
        break from the hectic lifestyle, for a vacation where you want time to
        run slower in a charming village atmosphere.
      </p>
      <div className="Content"></div>
    </div>
  );
};

export default About;
